export default () => ({
  showDamagePopup: false,
})
